export default __webpack_public_path__ + "static/media/Envelope.e9dd10f5.mov";